import * as React from 'react';

function ShotChart(props) {
  let strokeColor = 'white';
  let backgroundColor = 'black';

  return (
    <svg viewBox="0 0 500 470">
      {/*half court rectangle*/}
      <rect width="500" height="470" fill={backgroundColor} stroke={strokeColor} strokeWidth="2" />

      {/*3-point arc*/}
      <line x1="30" y1="0" x2="30" y2="140" stroke={strokeColor} strokeWidth="1" />
      <line x1="470" y1="0" x2="470" y2="140" stroke={strokeColor} strokeWidth="1" />  
      <path d="M 30 140 A 237.5 237.5 0 0 0 470 140" fill="none" stroke={strokeColor} strokeWidth="1.1" />
      
      {/*key*/}
      <rect x="170" width="160" height="190" fill="none" stroke={strokeColor} strokeWidth="1" />
      
      {/*backboard*/}
      <line x1="220" y1="40" x2="280" y2="40" stroke={strokeColor} strokeWidth="1" />

      {/*rim*/}
      <circle cx="250" cy="55" r="15" fill="none" stroke={strokeColor} strokeWidth="1" />    
      
      {/*restricted area*/}
      <path d="M 210 55 A 40 40 0 0 0 290 55" fill="none" stroke={strokeColor} strokeWidth="1" />
      
      {/*free throw circle*/}
      <path d="M 310 190 A 60 60 0 0 0 190 190" fill="none" stroke={strokeColor} strokeWidth="1" strokeDasharray="10,10" />
      <path d="M 190 190 A 60 60 0 0 0 310 190" fill="none" stroke={strokeColor} strokeWidth="1" />

      {/*shots*/}
      {
        props.shots.map((shot) => {
          return (
            <React.Fragment key={shot["3-Pointer Number"]}>
              <line
                x1={shot.LOC_X + 250}
                y1={shot.LOC_Y + 52}
                x2="250"
                y2="55"
                stroke={props.shotColorGenerator(shot)}
                strokeWidth={props.strokeWidth || "1"}
                opacity={props.opacity || "1"}>
                {(props.shouldAnimate && <React.Fragment>
                  <animate attributeName="y2" values={shot.LOC_Y + 52+";55"} dur="2s" />
                  <animate attributeName="x2" values={shot.LOC_X + 250+";250"} dur="2s" />
                </React.Fragment>)}
              </line>
              <circle
                cx={shot.LOC_X + 250}
                cy={shot.LOC_Y + 52}
                r="1"
                fill="white"
              />
            </React.Fragment>
          );
        })
      }
    </svg>
  );
}

export default ShotChart;